<template>
  <div class="vdl-membership" @click="onBadgeClick" v-if="isVisible">
    <md-tooltip md-direction="top" v-if="isAi">This is an A.I. generated voice actor profile</md-tooltip>
    <vdl-icon
      :icon="isAi ? 'AI-badge' : 'badge'"
      :mdIcon="false"
      :custom-icon="true"
      :html="isAi ? `<span class='path1'></span><span class='path2'></span>` : ``"
      :style="{'font-size': badgeInfo.size, color: badgeInfo.color}">
    </vdl-icon>
    <span v-if="showMembershipId" class="badge-number" :style="{ color:badgeInfo.color }">{{badgeInfo.number}}</span>
  </div>
</template>

<script src="./vdlBasicMembership.mjs"></script>
<style src="./vdlBasicMembership.scss" lang="scss" scoped></style>